import styled from "styled-components"
import media from "styled-media-query"

import { Clock } from "@styled-icons/evil/Clock"

import AniLink from "gatsby-plugin-transition-link/AniLink"

export const Primary = styled(AniLink)`
display: flex;
height: 520px;

${media.greaterThan("970px")`
  display: flex;
  width: 100%;
`}

  ${media.greaterThan("1040px")`
    width: 60%;
  `}

  ${media.greaterThan("1180px")`
    width: 64%;
  `}


${media.lessThan("1040px")`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  height: auto;
  margin-bottom: 0px;
  margin-right: 0;
`}

${media.lessThan("900px")`
  display: flex;
  flex-direction: column;
  height: auto;
  text-align: center;
  margin: 0;
`}
`

export const PrimaryPostImage = styled.section`
  display: flex;
  justify-content: center;
  position: relative;
  
  overflow: hidden;
  border-radius: 5px;
  background: #333;
  box-shadow: 2px 2px 3px 0px #0004;

  &:hover {
    box-shadow: 2px 2px 3px 0px var(--highlight);
  }

${media.greaterThan("1040px")`
  min-width: 100%;
  max-width: 100%;
  height: 500px;
`}

${media.greaterThan("1180px")`
  min-width: 97%;
  max-width: 97%;
  height: 345px;
`}

${media.lessThan("970px")`
  width: 440px;
  height: 290px;
`}

${media.greaterThan("500px")`
  height: auto;
  max-height: 470px;
  width: 92%;
`}

${media.greaterThan("680px")`
  height: auto;
  max-height: 500px;
  width: 96%;
`}

  ${media.greaterThan("1180px")`
    height: auto;
    max-height: 520px;
    width: 100%;
  `}

${media.lessThan("500px")`
  height: auto;
  max-height: 450px;
  width: 100%;
`}
`

export const Image = styled.img`
  width: auto;
  height: auto;
  opacity: 0.7;
  cursor: pointer;
  max-height: 500px;

  ${media.greaterThan("1180px")`
  height: auto;
  max-height: 520px;
`}

  ${media.lessThan("800px")`
    opacity: 0.5;
  `}
`

export const PrimaryText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  position: absolute;

  ${media.greaterThan("500px")`
    top: 100%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -100%);
    padding: 0 12%;
  `}

  ${media.greaterThan("1100px")`
    top: 100%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -100%);
    padding: 0 8%;
  `}

  ${media.lessThan("500px")`
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    padding: 0 24px;
  `}
`

export const PrimaryTitle = styled.h1`
  font-weight: 600;
  font-size: 30px;
  line-height: 44px;
  color: #ffffff;

  ${media.greaterThan("500px")`
    font-size: 30px;
    line-height: 1.4;
    text-align: left;
  `}

  ${media.lessThan("500px")`
    font-size: 28px;
    line-height: 1.3;
    text-align: left;
  `}
`

export const Infos = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  margin: 15px 0;
  font-size: 16px;
  color: #ffffff;

  ${media.greaterThan("500px")`
    margin: 40px 0;
    align-items: center;
  `}

  ${media.greaterThan("700px")`
    margin: 20px 0 40px;
    align-items: center;
  `}

  ${media.lessThan("500px")`
    margin: 30px 0 8px;
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const Name = styled.span`
  color: #efefef;
  font-weight: bold;
  margin-right: 15px;
  margin-left: 0px;

  ${media.lessThan("500px")`
    margin-left: 0px;
  `}
`

export const Author = styled.div`
  ${media.lessThan("500px")`
    margin-bottom: 10px;
  `}
`

export const ClockIcon = styled(Clock)`
  width: 22px;
  margin-right: 2px;
  color: var(--colorClock);

  ${media.lessThan("800px")`
    display: none;
  `}
`

export const Date = styled.div``
